import React, { ReactElement, useCallback, useMemo } from 'react'

import DecimalInput from '../../../../../../../1stlog-ui/src/components/DecimalInput'
import Field, {
  composeValidators,
} from '../../../../../../../1stlog-ui/src/components/Field'
import useFieldState from '../../../../../../../1stlog-ui/src/components/Field/useFieldState'
import {
  maxValue,
  mustBeFloat,
  required,
} from '../../../../../../../1stlog-ui/src/components/Field/Validation'
import { useProductSettings } from '../../../../Products'
import { ReadonlyVolume } from './ReadonlyVolume'

type TVolumeProps = {
  readonly?: boolean
}

const Volume = (props: TVolumeProps): ReactElement => {
  const { readonly } = props

  const { maxVolume, isMeasurementsHidden } = useProductSettings()

  const [allowCustomVolume] = useFieldState<boolean>('allowCustomVolume')

  const getValidate = useCallback(
    () =>
      composeValidators(
        mustBeFloat,
        required,
        maxVolume && maxVolume > 0 ? maxValue(maxVolume) : undefined,
      ),
    [maxVolume],
  )

  const allowInput = useMemo(
    () => Boolean(!readonly && allowCustomVolume),
    [readonly, allowCustomVolume],
  )

  if (isMeasurementsHidden) {
    return <></>
  }

  return (
    <>
      <div style={{ maxWidth: allowInput ? '130px' : 'auto' }}>
        <Field
          key={`${maxVolume}_${allowInput}`}
          name="volume"
          label={
            allowInput
              ? i18n.t('volume_in_cubic_m', 'Volumen in m³')
              : i18n.t('volume', 'Volumen')
          }
          required={allowInput}
          validate={getValidate()}
        >
          {!allowInput ? (
            <ReadonlyVolume readonly={readonly} />
          ) : (
            <DecimalInput minimumFractionDigits={2} />
          )}
        </Field>
      </div>
    </>
  )
}

export default Volume
